{
  "title": "Gift of Alacrity",
  "source": "Explorer's Guide to Wildemount",
  "levelAndSchool": "1st-level divination (dunamancy:chronurgy)",
  "level": 1,
  "castingTime": "1 minute",
  "range": "Touch",
  "components": "V, S",
  "duration": "8 hours",
  "description": [
    "You touch a willing creature. For the duration, the target can add 1d8 to its initiative rolls."
  ],
  "spellLists": ["wizard"]
}
